import styled from "styled-components";

export const FaqPartList = styled.ul`
  gap: 8px;
  display: flex;
  flex-direction: column;
`;
